import React from 'react';
import styles from './VideoGuide.module.scss';
import {$t} from '../../../helpers/translator';
import videos from "../../../dictionaries/videos";
import YoutubeVideo from "../../miscellaneous/YoutubeVideo/YoutubeVideo";
// import changeMachineTreatmentMode from "../../../assets/videoThumbnails/changeMachineTreatmentMode.jpg";
// import staffPerformanceAnalysis from "../../../assets/videoThumbnails/staffPerformanceAnalysis.jpg";
// import smartClinicCrashCourse from "../../../assets/videoThumbnails/smartClinicCrashCourse.jpg";
// import notificationsAndAlerts from "../../../assets/videoThumbnails/notificationsAndAlerts.jpg";
// import editPatientDetails from "../../../assets/videoThumbnails/editPatientDetails.jpg";
// import addNewStaffMembers from "../../../assets/videoThumbnails/addNewStaffMembers.jpg";
// import editAccountDetails from "../../../assets/videoThumbnails/editAccountDetails.jpg";



class VideoGuide extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            filteredVideos: null,
            filterString: '',
            selectedVideo: null
        };
    }

    async componentDidMount() {
        // await this.init();
        this.setState({
            filteredVideos: videos,
            selectedVideo: videos.connectADevice
        }, () => {

        })
    }

    selectVideo(video) {
        this.setState({selectedVideo: this.state.filteredVideos[video]});
    }

    render() {
        let filteredVideos = this.state.filteredVideos;
        let selectedVideo = this.state.selectedVideo;


        return (
            <div className={`alma-box ${styles['container']}`}>
                <div className={'alma-box-header'}>
                    <span><h3>{$t('global.helpCenter.videoGuides')}</h3></span>
                </div>

                <div className={`${styles['main-video']}`}>
                    {this.state.selectedVideo &&
                        <>
                            <div className={`${styles['large-video-name']}`}>
                                {$t('global.videos.'+selectedVideo.nameKey)}
                            </div>
                            <YoutubeVideo embedId={selectedVideo.embedId} />
                        </>
                    }
                </div>

                {filteredVideos ?
                    <div className={`${styles['video-list-container']}`}>
                        {Object.keys(filteredVideos).map((video, k) => (
                            <div className={`${styles['video-list-entry']} 
                            ${(filteredVideos[video].nameKey === selectedVideo.nameKey ? 'selected' : '')}`}
                                 onClick={() => this.selectVideo(video)}
                                 key={k}
                            >

                                <img src={`https://img.youtube.com/vi/${filteredVideos[video].embedId}/default.jpg`} alt="" className={`${styles['img']}`}/>
                                <div className={`${styles['small-video-name']}`}>
                                    {$t('global.videos.'+filteredVideos[video].nameKey)}
                                </div>
                            </div>
                        ))}
                    </div>
                :
                null
                }
            </div>
        );
    }
}

export default VideoGuide;
